import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/site/Footer";
import Logo from "@/components/site/Logo";

export default function MentionsLegales() {
  useEffect(() => {
    document.title = "Mentions légales — Solmis Habitat";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white text-foreground min-h-screen">
      {/* Minimal nav */}
      <header className="border-b border-border bg-white/90 backdrop-blur-md sticky top-0 z-40">
        <div className="container-wide flex h-20 items-center justify-between">
          <Link to="/" data-testid="ml-logo" className="block">
            <Logo withTagline variant="dark" />
          </Link>
          <Link
            to="/"
            data-testid="ml-back"
            className="inline-flex items-center gap-2 text-sm text-primary/85 hover:text-[hsl(var(--brand-terra))] transition-colors"
          >
            <ArrowLeft size={16} strokeWidth={1.6} />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <main className="py-20 md:py-28">
        <article className="container-narrow">
          <div className="flex items-center gap-3 mb-6">
            <span className="rule" />
            <span className="overline">Informations légales</span>
          </div>
          <h1 className="font-display text-5xl md:text-6xl text-primary leading-[1.05]">
            Mentions{" "}
            <span className="italic font-light text-[hsl(var(--brand-terra))]">
              légales
            </span>
          </h1>
          <p className="mt-5 text-base text-muted-foreground">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}
          </p>

          <div className="mt-14 space-y-12 text-[15px] leading-relaxed text-primary/90">
            <Section title="Éditeur du site">
              <p>
                Le site <strong>Solmis Habitat</strong> est édité par la
                société <strong>EM GROUP</strong>.
              </p>
              <ul className="mt-4 space-y-1.5 text-primary/85">
                <li><strong>EM GROUP</strong></li>
                <li>SAS (Société par Actions Simplifiée)</li>
                <li>SIRET : 100 603 026 00012</li>
                <li>Siège social : 60 rue François Ier, 75008 Paris, France</li>
                <li>Email : contact@solmishabitat.re</li>
                <li>Téléphone / WhatsApp : +262 693 52 10 19</li>
              </ul>
              <p className="mt-4">
                <strong>Directeur de publication :</strong> EM GROUP
              </p>
            </Section>

            <Section title="Hébergement">
              <p>
                Le site est hébergé par <strong>Emergent</strong>.
              </p>
            </Section>

            <Section title="Activité">
              <p>
                Solmis Habitat est une marque exploitée par la société EM
                GROUP, proposant des services d'accompagnement de projets de
                construction, incluant études de sol, permis de construire et
                prestations associées.
              </p>
            </Section>

            <Section title="Responsabilité">
              <p>
                Les informations présentes sur ce site sont fournies à titre
                indicatif. EM GROUP s'efforce d'assurer l'exactitude des
                informations mais ne saurait être tenue responsable
                d'éventuelles erreurs ou omissions.
              </p>
            </Section>

            <Section title="Propriété intellectuelle">
              <p>
                L'ensemble du contenu du site (textes, images, logos, éléments
                graphiques) est la propriété exclusive de EM GROUP, sauf
                mention contraire.
              </p>
              <p className="mt-3">
                Toute reproduction, distribution ou utilisation sans
                autorisation est interdite.
              </p>
            </Section>

            <Section title="Données personnelles">
              <p>
                Les données collectées via le site sont utilisées uniquement
                dans le cadre des demandes de contact et de devis.
              </p>
              <p className="mt-3">
                Conformément à la réglementation en vigueur, vous disposez
                d'un droit d'accès, de rectification et de suppression de vos
                données. Pour toute demande, contactez-nous à{" "}
                <a
                  href="mailto:contact@solmishabitat.re"
                  className="text-[hsl(var(--brand-terra))] underline underline-offset-4 hover:no-underline"
                >
                  contact@solmishabitat.re
                </a>
                .
              </p>
            </Section>
          </div>

          <div className="mt-16 pt-10 border-t border-border flex flex-wrap items-center gap-4">
            <Link
              to="/"
              data-testid="ml-back-bottom"
              className="btn-primary"
            >
              <ArrowLeft size={16} strokeWidth={1.8} />
              Retour à l'accueil
            </Link>
            <Link
              to="/politique-confidentialite"
              className="text-sm text-primary/85 hover:text-[hsl(var(--brand-terra))] underline underline-offset-4"
            >
              Voir la politique de confidentialité
            </Link>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-2xl md:text-3xl text-primary leading-snug">
        {title}
      </h2>
      <span className="block h-0.5 w-10 bg-[hsl(var(--brand-terra))] mt-3 mb-5" />
      <div className="space-y-2">{children}</div>
    </section>
  );
}
